import React from "react";
import { CheckCircle2 } from "lucide-react";
import { PROBLEM_LIST, SOLUTION_LIST, slugify } from "./constants";

export function LandingProblem() {
  return (
    <section className="py-20 border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">The problem</div>
        <h2 className="font-display font-black tracking-tight text-4xl lg:text-5xl mt-3">Hospitality Losses Are Rising</h2>
        <p className="mt-4 text-zinc-700 max-w-2xl mx-auto">
          Hotels and lodging providers face a rising tide of operational risk, yet most properties operate in isolation with no trusted way to share verified incident intelligence.
        </p>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 text-left">
          {PROBLEM_LIST.map(({ label, icon: I }) => (
            <div
              key={label}
              className="border border-zinc-200 rounded-md p-5 bg-white hover:shadow-md transition-shadow"
              data-testid={`problem-${slugify(label)}`}
            >
              <I className="w-5 h-5 text-rose-700 mb-3" />
              <div className="font-medium">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function LandingSolution() {
  return (
    <section className="py-20 border-b border-zinc-200 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">The solution</div>
        <h2 className="font-display font-black tracking-tight text-4xl lg:text-5xl mt-3">Introducing GuestIntel</h2>
        <p className="mt-4 text-zinc-700 max-w-2xl mx-auto">A Hospitality Intelligence Network built to help participating properties:</p>
        <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-3xl mx-auto text-left">
          {SOLUTION_LIST.map((s) => (
            <li key={s} className="flex items-center gap-2 bg-white border border-zinc-200 rounded-md px-4 py-3">
              <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" /><span className="text-sm">{s}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
